import { useEffect, useState } from 'react'
import { collection, query, where, orderBy, limit, onSnapshot } from 'firebase/firestore'
import { db } from '@fleetops/firebase'
import { firestorePaths } from '@fleetops/types'
import type { AppNotification } from '@fleetops/types'
import { useSession } from '@/store/auth.store'
import { subscriptionError } from '@/lib/firestoreError'

export function useNotifications() {
  const session = useSession()
  const [notifications, setNotifications] = useState<AppNotification[]>([])

  useEffect(() => {
    if (!session) return
    const q = query(
      collection(db, firestorePaths.notifications(session.tenantId)),
      where('tenantId', '==', session.tenantId),
      where('userId', '==', session.uid),
      orderBy('createdAt', 'desc'),
      limit(30),
    )
    return onSnapshot(q, (snap) => {
      setNotifications(snap.docs.map((d) => ({ id: d.id, ...d.data() }) as AppNotification))
    }, subscriptionError('as notificações'))
  }, [session?.tenantId, session?.uid])

  const unreadCount = notifications.filter((n) => !n.read).length
  return { notifications, unreadCount }
}
